/**
 * Evaluation thresholds mirrored from gpx-device-api ConvoyRules / ShipmentHandler.
 * SI metres and seconds for convoy; legacy minutes kept for delayed/no-movement copy.
 * Proximity metres: single SPA source is CONVOY_PROXIMITY_RADIUS_METERS (sync with PHP ConvoyRules).
 */
import { CONVOY_PROXIMITY_RADIUS_METERS } from '@/map/operational/convoy/constants';

export const SHIPMENT_EXCEPTION_RULES = {
  delayedPickupGraceMinutes: 60,
  noMovementDisplacementMeters: 500,
  noMovementWindowMinutes: 120,
  /** Same value as ConvoyRules::PROXIMITY_RADIUS_METERS / CONVOY_PROXIMITY_RADIUS_METERS */
  trackerSeparatedProximityMeters: CONVOY_PROXIMITY_RADIUS_METERS,
  /** ConvoyRules::HYSTERESIS_SEC (for copy if needed) */
  trackerSeparatedHysteresisSec: 120,
} as const;
